var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-field',{attrs:{"rules":_vm.rules,"type":_vm.show ? 'text' : 'password',"append-icon":_vm.show ? 'mdi-eye' : 'mdi-eye-off',"label":_vm.label},on:{"append":function($event){_vm.show = !_vm.show}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})
}
var staticRenderFns = []

export { render, staticRenderFns }